import { render, staticRenderFns } from "./DetailPenerbitanMenungguPembayaran.vue?vue&type=template&id=42a288f0&"
import script from "./DetailPenerbitanMenungguPembayaran.vue?vue&type=script&lang=js&"
export * from "./DetailPenerbitanMenungguPembayaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports